const AnswerCallButtonStyle = `
  min-width: unset;
  width: 100%;
`;

export default AnswerCallButtonStyle;
